require("/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/$_mfplugin_virtualInitConfig/index.js");